export default {
    setReports(state, {reports})
    {
        state.reports = reports;
    },
}
